/**
 * Created by piotr@revisual.io on 25/07/2025.
 */
import { useCurrentOrganizationStore } from "../../../../hooks/redux/currentOrganization";
import { useCallback, useState } from "react";
import { useAppStore } from "../../../../hooks/redux/app";
import appConfig from "../../../../appConfig";

const GraceThreshold = () => {
  const { currentOrganization } = useCurrentOrganizationStore();
  const { app, showGraceModal } = useAppStore();

  const onShowModalClick = useCallback(
    (e) => {
      showGraceModal(true);
    },
    [app.showGraceModal]
  );

  if (
    !currentOrganization ||
    (!currentOrganization.model.created > 1755664392 &&
      appConfig.branding !== "dc")
  ) {
    return null;
  }

  return (
    <div>
      <div className={"text-info cursor-info"} onClick={onShowModalClick}>
        What's this?
      </div>
    </div>
  );
};

export default GraceThreshold;
